import React from "react";
import OnboardHeading from "../OnboardHeading";
import BackButtonComponent from "../backButton";
import "./style.scss";

function TitleComp({ selectedEmployee, handleCreateFlow, flowUrl }) {
  const companyName = localStorage.getItem("company_name");
  return (
    <>
      <div className="d-flex justify-content-between employee-btn-wrapper flex-column flex-sm-row flex-md-row align-items-sm-center">
        <OnboardHeading title="DEDUCTION" subtitle={companyName} />
        {flowUrl ? null : (
          <div className="button-deducation-sub-wrapper">
            <button
              className={selectedEmployee.userId ? "" : "opacity-50 disabled"}
              onClick={selectedEmployee.userId ? handleCreateFlow : null}
            >
              Proceed to Deduction
            </button>
          </div>
        )}
      </div>
      <BackButtonComponent
        reDirectionpath={`https://app.guhroo.co/clients/payroll`}
      />
    </>
  );
}

export default TitleComp;
